import { BaseDocumentId } from "../base-document-id";
import type {
	DocumentGenerationVersion,
	DocumentHistoryVersion,
	DocumentUniqueId,
} from "../types";

export class DraftDocumentId extends BaseDocumentId {
	constructor(
		id: DocumentUniqueId,
		generationVersion?: DocumentGenerationVersion,
		historyVersion?: DocumentHistoryVersion,
	) {
		super("draft", id, generationVersion, historyVersion);
	}

	atGenerationVersion(generationVersion: DocumentGenerationVersion) {
		return new DraftDocumentId(this.id, generationVersion, this.historyVersion);
	}

	atHistoryVersion(historyVersion: DocumentHistoryVersion) {
		return new DraftDocumentId(this.id, this.generationVersion, historyVersion);
	}
}
